module.exports = __webpack_public_path__ + "img/album18_24.6a7a9bd6.jpg";